import { Lead } from "@/backend/commands/push-lead/types"
import { getQueryParameter } from "@punks/ui-core"
import axios from "axios"

type LoadInput = Pick<
  Lead,
  "firstName" | "lastName" | "email" | "phone" | "message" | "category"
>

const enrichLead = (data: LoadInput): Lead => {
  return {
    ...data,
    source: getQueryParameter("source") || "Website",
    utmSource: getQueryParameter("utm_source"),
    utmMedium: getQueryParameter("utm_medium"),
    utmCampaign: getQueryParameter("utm_campaign"),
    channel: "Website Form",
    originalUrl: window.location.href,
  }
}

export const invokePushLead = async (input: LoadInput) => {
  return await axios.post("/api/pushLead", enrichLead(input))
}
